import React from 'react';
import ReactModal from 'react-modal';

/**
 * Confirm modal component
 * @param {String} title modal title
 * @param {String} description modal description text
 * @param {Boolean} isOpen open or close flag
 * @param {String} confirmBtnText confirm button label
 * @param {String} cancelBtnText cancel button label
 * @param {Function} content some components or html to render in body
 * @param {Function} onConfirm confirm button handler
 * @param {Function} onClose cancel/close modal handler
 */
const ConfirmModal = ({
  onConfirm,
  onClose,
  confirmBtnText = 'Confirm',
  cancelBtnText = 'Cancel',
  isOpen = false,
  title = 'Confirm Modal',
  description = 'Are you sure?',
  closeOnConfirmClick = true,
  content = null,
  className,
}) => {
  const confirmHandler = (e) => {
    onConfirm(e);
    closeOnConfirmClick && onClose();
  };

  return (
    <ReactModal
      appElement={document.getElementById('root')}
      isOpen={isOpen}
      contentLabel="Confirm Cancel Purchase Modal"
      portalClassName="AdjustmentCreditPortal"
      overlayClassName="AdjustmentCreditModal__Overlay"
      className={'AdjustmentCreditModal__Content ' + className}
    >
      <div className="modal-header">
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <h2>{title}</h2>
      </div>
      <div className="modal-body">
        <div>{description}</div>
        {content}
      </div>
      <div className="modal-footer">
        <button className="btn btn-primary" onClick={confirmHandler}>
          {confirmBtnText}
        </button>
        <button className="btn" onClick={onClose}>
          {cancelBtnText}
        </button>
      </div>
    </ReactModal>
  );
};

export default ConfirmModal;
